import { render, staticRenderFns } from "./GamePage.vue?vue&type=template&id=c763efe4&scoped=true"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"
import style0 from "./GamePage.vue?vue&type=style&index=0&id=c763efe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c763efe4",
  null
  
)

export default component.exports